import { useCallback, useEffect, useState } from "react";
import { useMessage } from "../../../hooks/useMessage";

/**
 * Get the color tweaks in full range values
 * This will update the values synchronously, this can lead to incorrect values
 * Remark: useMessageToState?
 */

const getNewTweaks = (selectedZone?: eXpress.core.IZone) => {
	return (
		(eXpress.core.isPhotoZone(selectedZone) && selectedZone.getPhotoLook()?.colorTweaks) ||
		eXpress.core.ColorTweaks.empty
	);
};

export const useSelectedColorTweaks = (selectedZone: eXpress.core.IZone | undefined) => {
	const [tweaks, setTweaks] = useState(() => getNewTweaks(selectedZone));

	const updateTweaks = useCallback(() => {
		const newTweaks = getNewTweaks(selectedZone);
		setTweaks(newTweaks);
	}, [selectedZone]);

	useMessage(updateTweaks, {
		captureInteractiveMessages: true, // TODO: Investigate if it is too slow to use setState for interactive messages
	});

	// If zone is changed, update with the values from the new zone
	useEffect(updateTweaks, [selectedZone, updateTweaks]);

	return tweaks;
};
